import {createApi} from "@reduxjs/toolkit/query/react";
import {baseQueryWithReAuth} from "@/store/api/baseQueryWithReAuth";

export interface Package {
    id: number;
    country?: string;
    package?: string;
    recommend_state?: string;
    category?: string;
    name: string;
    summary?: string;
    sub_summary?: string;
    description?: string;
    amount: number;
    type?: string;
    existing_llc?: string;
    status?: number;
    sort?: string;
    country_type?: string;
    package_name?: string;
    recommend_state_name?: string;
    country_name?: string;
    state_fee?: number;
}

export const packageApi = createApi({
    reducerPath: "packageApi",
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getPackages: builder.query<Package[], number | null>({
            query: (country_id) => `/package${country_id ? `?country_id=${country_id}` : ""}`,
        }),
    }),
});

export const { useGetPackagesQuery } = packageApi;
